import { IDatiqGraphCard } from './datiq-graph-card.interface';
import { emptyDatiqGraphCardChart } from '../../datiq-graph-card-chart';

export const emptyDatiqLaneCard: IDatiqGraphCard = {
    chart: { ...emptyDatiqGraphCardChart },
};
